module.exports = __webpack_public_path__ + "img/秒杀中背景.c2a18303.png";